import { login as loginApi, getUserInfo, logout as logoutApi } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  name: '',
  userInfo: null
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
  },
  RESET_STATE: state => {
    state.token = ''
    state.name = ''
    state.userInfo = null
  }
}

const actions = {
  login({ commit }, userInfo) {
    return loginApi({
      username: userInfo.username,
      password: userInfo.password
    }).then(data => {
      const token = data.token
      if (!token) {
        return Promise.reject(new Error('登录成功但未返回 token'))
      }
      commit('SET_TOKEN', token)
      setToken(token)
      commit('SET_NAME', userInfo.username)
    })
  },

  getInfo({ commit, dispatch }) {
    return getUserInfo().then(data => {
      commit('SET_USER_INFO', data)
      commit('SET_NAME', data.username || 'admin')
      const sid = data.substation_id != null ? Number(data.substation_id) : null
      // 驿站管理员：锁定 subsite 头为其绑定驿站，并用单条驿站填充列表
      if (sid != null && sid > 1) {
        dispatch('app/setSubSiteId', sid, { root: true })
        const sname = data.substation_name || data.substationName || '本驿站'
        dispatch('app/setSubSiteList', [{ id: sid, name: sname }], { root: true })
      }
      return data
    })
  },

  logout({ commit }) {
    return logoutApi()
      .catch(() => {})
      .finally(() => {
        removeToken()
        commit('RESET_STATE')
      })
  },

  resetToken({ commit }) {
    removeToken()
    commit('RESET_STATE')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
